import React from "react";
import styles from "./Label.css";

const Label = function ({ label, children, row }) {
  return (
    <label
      className={styles.Label}
      style={row ? { flexDirection: "row", gap: "1rem" } : null}
    >
      <span className={styles.Text}>{label}</span>
      {children}
    </label>
  );
};

export default Label;
